import type {
  CombinedError,
  AnyVariables, ClientHandle, OperationContext,
} from '@urql/vue';
import type { DocumentNode } from 'graphql';

const getUrqlErrorMessage = (error: CombinedError): string => (
  error.graphQLErrors[0]?.message
  ?? error.networkError?.message
  ?? error.message
);

const useUrqlUpdate = <Mutation, Variables extends AnyVariables>(
  urql: ClientHandle,
  document: DocumentNode,
  name: keyof Mutation,
) => {
  const toast = useToast();
  const mutation = urql.useMutation<Mutation, Variables>(document);
  const onSubmitUrql = async (
    variables: Variables,
    actions?: {
      onError?: (value: CombinedError) => void,
      onSuccess?: (value: Mutation) => void,
    },
    context?: Partial<OperationContext>,
    successMessage?: string,
  ) => {
    const response = await mutation.executeMutation(variables, context);
    if (response.data && response.data[name]) {
      if (actions?.onSuccess) {
        actions?.onSuccess(response.data);
      } else {
        toast.add({ title: successMessage ?? 'Changes saved', color: 'success' });
      }
    } else if (response.error) {
      if (actions?.onError) {
        actions?.onError(response.error);
      } else {
        toast.add({ title: getUrqlErrorMessage(response.error), color: 'error' });
      }
    }
    return response;
  };
  return {
    ...mutation,
    onSubmitUrql,
  };
};

export default useUrqlUpdate;
